import React, {useEffect, useState} from 'react';
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";
import logo from "../../../assets/images/RMI-Logo.png"

const RMIForm = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [filteredRegistrationData, setFilteredRegistrationData] = useState([]);

    const [credentials] = useState({
        username: "RMI_Dentistry",
        password: "Live@rd24",
        clientId: "Z974nvvcnbsyhM5",
        clientSecret: "4D59Z8Nx0Er1OhK"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        cnic: '',
        passport:"",
        nationality:"",
        nameOfInstitute:"",
        studentIdOrEmployeeId:"",
        institution:"",
        department:"",
        designation:"",
        specialty:"",
        phoneNumber:"",
        emailAddress:"",
        alternateEmailAddress:"",
        address:"",
        city:"",
        province:"",
        state:"",
        country:"",
        modeOfParticipation:"",
        registration:"",
        galaDinner:"",
        nationStudentPricing:"",
        internationStudentPricing:"",
        nationProfessionalPricing:"",
        internationProfessionalPricing:"",
        rmiStudentPricing:"",
        rmiProfessionalPricing:""

    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData?.registration === "National" && formData?.nationality === 'Pakistani' &&  formData?.institution === 'Others')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: parseInt(formData?.nationStudentPricing || 0) + (formData.galaDinner ? 1500 : 0),
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.phoneNumber?? '',
                CustomerEmail: formData?.emailAddress?? '',
                CustomerAddress: formData?.address?? '',
                        cnic: formData?.cnic,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData?.galaDinner ? "1500" : '0',
                        nationStudentPricing:formData?.nationStudentPricing,
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""


            }
        ];
    }
     else if(formData?.registration === "NationalPostgraduateScholars/Professionals" && formData?.nationality === 'Pakistani' &&  formData?.institution === 'Others')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: parseInt(formData?.nationProfessionalPricing || 0) + (formData.galaDinner ? 1500 : 0),
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.phoneNumber?? '',
                CustomerEmail: formData?.emailAddress?? '',
                CustomerAddress: formData?.address?? '',

                        cnic: formData?.cnic,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData?.galaDinner ? "1500" : '0',
                        nationProfessionalPricing:formData?.nationProfessionalPricing,
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""

            }
        ];
    }
    else if(formData?.registration === "International" && formData?.nationality === 'Foreign')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.internationStudentPricing,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: "",
                CustomerEmail: formData?.emailAddress,
                CustomerAddress: formData?.address,
                Currency: 'USD',
                IsConverted  : "true",

                        phoneNumber:formData?.phoneNumber,
                        passport: formData?.passport,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData.galaDinner,
                        nationStudentPricing:formData?.internationStudentPricing+"USD",
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""


            }
        ];
    }
    else if(formData?.registration === "InternationalPostgraduateScholars/Professionals" && formData?.nationality === 'Foreign')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.internationProfessionalPricing,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: "",
                CustomerEmail: formData?.emailAddress,
                CustomerAddress: formData?.address,
                Currency: 'USD',
                IsConverted  : "true",

                        phoneNumber:formData?.phoneNumber,
                        passport: formData?.passport,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData.galaDinner,
                        nationStudentPricing:formData?.internationProfessionalPricing+"USD",
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""

            }
        ];
    }
    else if(formData?.registration === "National" && formData?.nationality === 'Pakistani' &&  formData?.institution === 'RehmanMedicalInstitute')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: parseInt(formData?.rmiStudentPricing || 0) + (formData.galaDinner ? 1500 : 0),
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.phoneNumber?? '',
                CustomerEmail: formData?.emailAddress?? '',
                CustomerAddress: formData?.address?? '',

                        cnic: formData?.cnic,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData?.galaDinner ? "1500" : '0',
                        rmiStudentPricing:formData?.rmiStudentPricing,
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""

            }
        ];
    }
    else if(formData?.registration === "NationalPostgraduateScholars/Professionals" && formData?.nationality === 'Pakistani' &&  formData?.institution === 'RehmanMedicalInstitute')
    {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: parseInt(formData?.rmiProfessionalPricing || 0) + (formData.galaDinner ? 1500 : 0),
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.phoneNumber?? '',
                CustomerEmail: formData?.emailAddress?? '',
                CustomerAddress: formData?.address?? '',

                        cnic: formData?.cnic,
                        nationality: formData?.nationality ?? '',
                        institution: formData?.institution ?? '',
                        department: formData?.department ?? '',
                        designation: formData?.designation ?? '',
                        specialty: formData?.specialty ?? '',
                        alternateEmailAddress: formData?.alternateEmailAddress ?? '',
                        city: formData?.city ?? '',
                        province: formData?.province ?? '',
                        country: formData?.country ?? '',
                        modeOfParticipation: formData?.modeOfParticipation?? '',
                        registration: formData?.registration?? '',
                        galaDinner: formData?.galaDinner ? "1500" : '0',
                        rmiProfessionalPricing:formData?.rmiProfessionalPricing,
                        nameOfInstitute:formData?.nameOfInstitute??"",
                        studentIdOrEmployeeId:formData?.studentIdOrEmployeeId??""

            }
        ];
    }






    const modeOfParticipationData = [
        { id: 1, name: "In Person", value: "inperson" },
        { id: 2, name: "Online", value: "online" },
    ];

    const nationalityData = [
        { id: 1, name: "Pakistani", value: "Pakistani" },
        { id: 2, name: "Foreign", value: "Foreign" },

    ];

    const institutionData = [
        { id: 1, name: "Rehman Medical Institute", value: "RehmanMedicalInstitute" },
        { id: 2, name: "Others", value: "Others" },

    ];

    const specialtyData = [
        { id: 1, name: "Medical", value: "Medical" },
        { id: 2, name: "Dental", value: "Dental" },
        { id: 3, name: "Physiotherapy", value: "Physiotherapy" },
        { id: 4, name: "Nursing", value: "Nursing" },
        { id: 5, name: "Pharmacy", value: "Pharmacy" },
        { id: 6, name: "Biotechnology", value: "Biotechnology" },
        { id: 7, name: "Allied Health Sciences", value: "AlliedHealthSciences" },

    ];

    const registrationData = [
        { id: 2, name: "National", value: "National" },
        { id: 3, name: "National PostgraduateScholars/Professionals", value: "NationalPostgraduateScholars/Professionals" },
        { id: 4, name: "International", value: "International" },
        { id: 5, name: "International PostgraduateScholars/Professionals", value: "InternationalPostgraduateScholars/Professionals" },
    ];





    const nationStudentPricingData = [
        { id: 1, name: "Early Bird", value: "2500",currency:"PKR" },
        { id: 2, name: "Standard", value: "3500",currency:"PKR" },
        { id: 3, name: "Last Minute/ On Spot", value: "4500",currency:"PKR" },
    ];
    const nationProfessionalPricingData = [
        { id: 1, name: "Early Bird", value: "3500",currency:"PKR" },
        { id: 2, name: "Standard", value: "4500",currency:"PKR" },
        { id: 3, name: "Last Minute/ On Spot", value: "5000",currency:"PKR" },
    ];
    const internationStudentPricingData = [
        { id: 1, name: "Early Bird", value: "30",currency:"USD" },
        { id: 2, name: "Standard", value: "50",currency:"USD" },
        { id: 3, name: "Last Minute/ On Spot", value: "70",currency:"USD" },

    ];
    const internationProfessionalPricingData = [
        { id: 1, name: "Early Bird", value: "50",currency:"USD" },
        { id: 2, name: "Standard", value: "75",currency:"USD" },
        { id: 3, name: "Last Minute/ On Spot", value: "100",currency:"USD" },

    ];

    const RMIStundentPricingData = [
        { id: 1, name: "Early Bird", value: "2000",currency:"PKR" },
        { id: 2, name: "Standard", value: "2800",currency:"PKR" },
        { id: 3, name: "Last Minute/ On Spot", value: "3600",currency:"PKR" },

    ];


    const RMIProfessionalPricingData = [
        { id: 1, name: "Early Bird", value: "2800",currency:"PKR" },
        { id: 2, name: "Standard", value: "3600",currency:"PKR" },
        { id: 3, name: "Last Minute/ On Spot", value: "4000",currency:"PKR" },

    ];



    // Handle input changes and update form data
    // Handle input changes and update form data with real-time validation
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "name":
                if (!value) {
                    fieldError.name = "Name is required.";
                } else {
                    fieldError.name = ""; // Clear error if input is valid
                }
                break;
            case "emailAddress":
                if (!value) {
                    fieldError.emailAddress = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.emailAddress = "Email address is invalid.";
                } else {
                    fieldError.emailAddress = ""; // Clear error if input is valid
                }
                break;
            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;
            case "studentIdOrEmployeeId":
                if (formData?.institution === "RehmanMedicalInstitute") {
                    if (!value) {
                        fieldError.studentIdOrEmployeeId = "Student ID / Employee ID is required.";
                    } else {
                        fieldError.studentIdOrEmployeeId = ""; // Clear error if input is valid.
                    }
                }
                break;

            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.name) newErrors.name = "Name is required.";

        // Check if the email is empty or not valid
        if (!formData.emailAddress) {
            newErrors.emailAddress = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.emailAddress)) {
            newErrors.emailAddress = "Email address is invalid.";
        }

        // Check if the phone number field is empty
        if (!formData.phoneNumber) newErrors.phoneNumber = "Mobile Number is required.";

        if (formData.institution === "RehmanMedicalInstitute" && !formData.studentIdOrEmployeeId) {
            newErrors.studentIdOrEmployeeId = "Student ID / Employee ID is required.";
        }

        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();



        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl+"&callback_url=https://conference.rmi.edu.pk/ichr25/ichr25-conference-registration/";
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }



    useEffect(() => {
        // Dynamically filter data based on nationality
        const filteredData = formData?.nationality === "Pakistani"
            ? registrationData.filter((item) => item.id === 2 || item.id === 3)
            : registrationData.filter((item) => item.id === 4 || item.id === 5);

        setFilteredRegistrationData(filteredData);
        setFormData((prevFormData) => ({
            ...prevFormData,
            registration: "",
            institution: ''
        }));
    }, [formData?.nationality]);

    return (
        <div className="w-11/12 lg:w-2/3 md:w-4/5 bg-white border-4 rounded-lg shadow relative m-auto">
            <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>
                <div className='w-full flex items-center justify-center'>
                    <img className='w-2/6' src={logo} alt={logo} />
                </div>
               <div className='w-full flex flex-col justify-center items-center gap-2'>
                   <h6 className='  text-2xl uppercase font-Poppins font-semibold '>ICHR-25</h6>
                   <h6 className=' text-2xl uppercase font-Poppins font-semibold '>International Conference Health Research 2025</h6>
                   <h6 className=' text-2xl uppercase font-Poppins font-semibold '>Conference Registration</h6>
               </div>
                <div className="w-full flex flex-col justify-between  items-center pt-4 gap-4">
                    <div className="w-full  grid grid-cols-6 gap-6">
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Name <span>*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={formData?.name}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Full Name"
                            />
                            {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Nationality</label>
                            <NewSelect
                                selectValue={formData?.nationality}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="nationality"
                                data={nationalityData}
                            />
                            {errors.nationality && <p className="text-red-600 text-sm">{errors.nationality}</p>}
                        </div>





                        {formData?.nationality === "Pakistani" ? (
                            <div className="col-span-6 sm:col-span-3">
                                <label className="text-md font-medium text-gray-900 block mb-2">CNIC</label>
                                <input
                                    type="text"
                                    name="cnic"
                                    value={formData?.cnic}
                                    onChange={handleChange}
                                    className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                    placeholder="CNIC (Without Dashes)"
                                />
                                {errors.cnic && <p className="text-red-600 text-sm">{errors.cnic}</p>}
                            </div>
                        ) : null}

                        {formData.nationality === 'Foreign' ? (
                            <div className="col-span-6 sm:col-span-3">
                                <label className="text-md font-medium text-gray-900 block mb-2">Passport</label>
                                <input
                                    type="text"
                                    name="passport"
                                    value={formData?.passport}
                                    onChange={handleChange}
                                    className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                    placeholder="Enter Passport Number"
                                />
                                {errors.passport && <p className="text-red-600 text-sm">{errors.passport}</p>}
                            </div>
                        ) : null}

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Institution</label>
                            <NewSelect
                                selectValue={formData?.institution}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="institution"
                                data={institutionData}
                            />
                            {errors.institution && <p className="text-red-600 text-sm">{errors.institution}</p>}
                        </div>

                        {formData?.institution === "RehmanMedicalInstitute" ? (<div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Employee ID/ Student ID <sapn>*</sapn></label>
                            <input
                                type="text"
                                name="studentIdOrEmployeeId"
                                value={formData?.studentIdOrEmployeeId}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder=""
                            />
                            {errors.studentIdOrEmployeeId && <p className="text-red-600 text-sm">{errors.studentIdOrEmployeeId}</p>}
                        </div>) : null}

                        {formData?.institution === "Others" ? (<div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Name of Institute</label>
                            <input
                                type="text"
                                name="nameOfInstitute"
                                value={formData?.nameOfInstitute}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder=""
                            />
                            {errors.nameOfInstitute && <p className="text-red-600 text-sm">{errors.nameOfInstitute}</p>}
                        </div>) : null}





                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Department</label>
                            <input
                                type="text"
                                name="department"
                                value={formData?.department}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Current Department"
                            />
                            {errors.department && <p className="text-red-600 text-sm">{errors.department}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Designation</label>
                            <input
                                type="text"
                                name="designation"
                                value={formData?.designation}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Current Designation"
                            />
                            {errors.designation && <p className="text-red-600 text-sm">{errors.designation}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Specialty</label>
                            <NewSelect
                                selectValue={formData?.specialty}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="specialty"
                                data={specialtyData}
                            />
                            {errors.specialty && <p className="text-red-600 text-sm">{errors.specialty}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Phone Number <span>*</span></label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={formData?.phoneNumber}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder={formData.nationality === "Pakistani" ? "Preferably WhatsApp (03XXXXXXXXX)" : "Preferably WhatsApp"}
                            />
                            {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Email Address <span>*</span></label>
                            <input
                                type="text"
                                name="emailAddress"
                                value={formData?.emailAddress}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder=""
                            />
                            {errors.emailAddress && <p className="text-red-600 text-sm">{errors.emailAddress}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Alternate Email Address</label>
                            <input
                                type="text"
                                name="alternateEmailAddress"
                                value={formData?.alternateEmailAddress}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Alternate Email Address"
                            />
                            {errors.alternateEmailAddress && <p className="text-red-600 text-sm">{errors.alternateEmailAddress}</p>}
                        </div>


                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Address</label>
                            <input
                                type="text"
                                name="address"
                                value={formData?.address}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Address"
                            />
                            {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">City</label>
                            <input
                                type="text"
                                name="city"
                                value={formData?.city}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="City"
                            />
                            {errors.city && <p className="text-red-600 text-sm">{errors.city}</p>}
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Province</label>
                            <input
                                type="text"
                                name="province"
                                value={formData?.province}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Province"
                            />
                            {errors.province && <p className="text-red-600 text-sm">{errors.province}</p>}
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">State</label>
                            <input
                                type="text"
                                name="state"
                                value={formData?.state}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="State"
                            />
                            {errors.state && <p className="text-red-600 text-sm">{errors.state}</p>}
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Country</label>
                            <input
                                type="text"
                                name="country"
                                value={formData?.country}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Country"
                            />
                            {errors.country && <p className="text-red-600 text-sm">{errors.country}</p>}
                        </div>


                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Mode Of Participation</label>
                            <NewSelect
                                selectValue={formData?.modeOfParticipation}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="modeOfParticipation"
                                data={modeOfParticipationData}
                            />
                            <span className="text-red-600 text-sm pt-1">Note: Mode can only be changed on request with subject to space availability.</span>
                            {errors.modeOfParticipation && <p className="text-red-600 text-sm">{errors.modeOfParticipation}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Registration</label>
                            <NewSelect
                                selectValue={formData?.registration}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="registration"
                                data={filteredRegistrationData}
                            />
                            {errors.registration && <p className="text-red-600 text-sm">{errors.registration}</p>}
                        </div>

                        {formData?.registration === "National" && formData?.nationality === 'Pakistani' && formData?.institution === 'Others'  ? (<div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">National Student</label>
                            <PricingWithNameSelect
                                selectValue={formData?.nationStudentPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="nationStudentPricing"
                                data={nationStudentPricingData}
                            />
                            {errors.nationStudentPricing && <p className="text-red-600 text-sm">{errors.nationStudentPricing}</p>}
                        </div>) : null}

                        {formData?.registration === 'NationalPostgraduateScholars/Professionals' && formData?.nationality === 'Pakistani' && formData?.institution === 'Others' ? (<div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">National Professional</label>
                            <PricingWithNameSelect
                                selectValue={formData?.nationProfessionalPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="nationProfessionalPricing"
                                data={nationProfessionalPricingData}
                            />
                            {errors.nationStudentPricing && <p className="text-red-600 text-sm">{errors.nationStudentPricing}</p>}
                        </div>) : null}


                        {formData?.registration === 'International' && formData?.nationality === 'Foreign' ? (  <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">International Student</label>
                            <PricingWithNameSelect
                                selectValue={formData?.internationStudentPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="internationStudentPricing"
                                data={internationStudentPricingData}
                            />
                        </div>) : null}

                        {formData?.registration === 'InternationalPostgraduateScholars/Professionals' && formData?.nationality === 'Foreign'  ? ( <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">International Professional</label>
                            <PricingWithNameSelect
                                selectValue={formData?.internationProfessionalPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="internationProfessionalPricing"
                                data={internationProfessionalPricingData}
                            />
                        </div>) : null}

                        {formData?.registration === 'National' && formData?.nationality === 'Pakistani' &&  formData?.institution === 'RehmanMedicalInstitute'  ? ( <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">RMI Student Pricing</label>
                            <PricingWithNameSelect
                                selectValue={formData?.rmiStudentPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="rmiStudentPricing"
                                data={RMIStundentPricingData}
                            />
                        </div>) : null}

                        {formData?.registration === 'NationalPostgraduateScholars/Professionals' && formData?.nationality === 'Pakistani' &&  formData?.institution === 'RehmanMedicalInstitute'  ? ( <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">RMI Professional Pricing</label>
                            <PricingWithNameSelect
                                selectValue={formData?.rmiProfessionalPricing}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="rmiProfessionalPricing"
                                data={RMIProfessionalPricingData}
                            />
                        </div>) : null}


                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Gala Dinner</label>
                            <div className="flex items-center">
                                <input
                                    type="checkbox"
                                    id="galaDinner"
                                    name="galaDinner"
                                    checked={formData?.nationality === 'Foreign' ? true : formData?.galaDinner || false}
                                    disabled={formData?.nationality === 'Foreign'}
                                    onChange={(e) =>
                                        setFormData({ ...formData, galaDinner: e.target.checked })
                                    }
                                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                />
                                <label htmlFor="galaDinner" className="ml-2 text-gray-700">
                                    {formData?.nationality === 'Foreign' ? 'Attending' : 'Attending (1500 PKR)'}
                                </label>
                            </div>
                            {errors.galaDinner && <p className="text-red-600 text-sm">{errors.galaDinner}</p>}
                        </div>


                    </div>

                </div>


                <div className="flex items-center justify-center">
                    <button
                       onClick={payproCreateOrder}
                        className="w-full text-center justify-center flex items-center gap-1  py-2 px-4 text-white bg-black  focus:ring-4 focus:ring-white font-medium rounded-lg text-md"

                    >
                        Proceed to Payment {loading ? <CircularLoader/> : null}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RMIForm;


export const NewSelect = ({ data, selectValue, setSelectValue, name }) => {
    return (
        <div className="w-full">
            <select
                value={selectValue || ""}  // Use selectValue to show the selected value
                onChange={(e) => setSelectValue(name, e.target.value)}  // Pass the name and value
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
            >
                <option value="" disabled>
                    Please select the option
                </option>

                {data?.map((item, index) => (
                    <option key={index} value={item?.value}>
                        {item?.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export const PricingWithNameSelect = ({ data, selectValue, setSelectValue, name }) => {
    return (
        <div className="w-full">
            <select
                value={selectValue || ""}  // Use selectValue to show the selected value
                onChange={(e) => setSelectValue(name, e.target.value)}  // Pass the name and value
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
            >
                <option value="" disabled>
                    Please select the option
                </option>

                {data?.map((item, index) => (
                    <option key={index} value={item?.value}>
                        {item?.name +" "+ item?.value+" "+ item?.currency }
                    </option>
                ))}
            </select>
        </div>
    );
};

